// Payload display: finding the line of an extracted field in the formatted payload (the colouring of the
// lines is the document peek's, in the design tokens).

/**
 * Line index of the `occurrence`-th appearance of a field in the formatted payload, or -1.
 * Matches the last path segment as an element / attribute / key, and the value on the same line.
 */
export function fieldLine(lines: string[], type: string, path: string, value: string, occurrence: number): number {
  const leaf = path.split('/').pop() ?? path;
  const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  let re: RegExp;
  if (type === 'xml') {
    re = leaf.startsWith('@')
      ? new RegExp(`\\s${esc(leaf.slice(1))}=["']${esc(xmlEscape(value))}["']`)
      : new RegExp(`<(?:[\\w.-]+:)?${esc(leaf)}[\\s>/]`);
  } else if (type === 'json') {
    re = new RegExp(`"${esc(leaf)}"\\s*:`);
  } else {
    return -1;
  }
  let seen = 0;
  for (let i = 0; i < lines.length; i++) {
    if (!re.test(lines[i])) continue;
    if (value && !leaf.startsWith('@') && !lines[i].includes(type === 'xml' ? xmlEscape(value) : value)) continue;
    if (seen === occurrence) return i;
    seen++;
  }
  return -1;
}

function xmlEscape(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
